import { Button, Checkbox, Heading, Label, Paragraph, Popup } from '@quickmd-llc/design-system';
import React, { useCallback, useState } from 'react';
import { setDontShowDeferConfirmation } from './utils';

type ConfirmDeferModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

// Shown only when the provider clicks the Defer button on the visit pop-up (not on browser Back).
export const ConfirmDeferModal: React.FC<ConfirmDeferModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmDeferModalProps) => {
  const [dontShow, setDontShow] = useState<boolean>(false);

  const handleToggle = useCallback((checked: boolean) => {
    setDontShow(checked);
    setDontShowDeferConfirmation(checked);
  }, []);

  return (
    <Popup
      onClose={onClose}
      isOpen={isOpen}
      showCloseIcon
      styles={{
        wrapperClassName: '!w-[500px] ',
        containerClassName: ' w-full ',
      }}
      header={{
        content: <Heading level="h3">Confirm you want to ‘Defer’ this visit.</Heading>,
      }}
      body={
        <div className="w-full max-w-md rounded-lg bg-white">
          <Paragraph className="text-text-medium">
            By deferring this visit, it will be moved back into the ‘Review’ queue.
          </Paragraph>

          <div
            className="mt-sp-3 flex cursor-pointer items-center"
            onClick={() => handleToggle(!dontShow)}
            role="presentation"
          >
            <Checkbox checked={dontShow} onChange={handleToggle} />
            <Label className="text-sm">Don’t show this confirmation again</Label>
          </div>
        </div>
      }
      footer={
        <div className="flex justify-end gap-sp-2">
          <Button priority="secondary" onClick={onClose}>
            Cancel
          </Button>

          <Button priority="primary" onClick={onConfirm}>
            Yes, Defer
          </Button>
        </div>
      }
    />
  );
};
